module.exports = __webpack_public_path__ + "img/logo-login-sem-fundo.62fc1471.svg";